import React, { useState, useEffect }  from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

const NoticeModal = ({ lgShow, setLgShow}) => {

  return (
    <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Announcement
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>ENGLISH Version</strong>:
            No changes is allowed to the registration details except change in emergency contact by email to <a href="mailto:support@marathonkuching.com ">support@marathonkuching.com </a>
            
            <br/><br/>

            <strong>BM Version</strong>:
            Tiada perubahan kepada butir-butir penyertaan akan dibenarkan kecuali hubungan kecemasan dengan emel ke <a href="mailto:support@marathonkuching.com ">support@marathonkuching.com </a>
          </p>
        </Modal.Body>
      </Modal>
  )

}

export default NoticeModal;